var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root",class:_vm.classes},[_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.$donatrix.message?.length))]),_c('span',{staticClass:"separator"},[_vm._v("/")]),_c('span',{staticClass:"limit"},[_vm._v(_vm._s(_vm.$donatrix.settings?.messageLimit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }